export const syncReviewEn = {
  loadingClassroom: "Loading Class in Order…",
  inviteTitle: "Google Drive sync",
  crossDeviceLabel: "Cross-device sync",
  closeSettings: "Close sync settings",
  setupProgress: "Sync setup progress",
  deviceStep: "Remember device",
  googleStep: "Authorize Drive",
  confirmStep: "Confirm connection",
  firstDeviceTitle: "Connect this device first",
  authorizeDriveTitle: "Connect your Google Drive",
  returnAfterGoogle: "After Google authorization, return here and choose Check authorization again.",
  connectedTitle: "Connected to Google Drive",
  manageDrive: "Google authorization settings",
  backToClassroom: "Return to Class in Order",
  optionalStep: "Optional setup",
  offerTitle: "Continue on your computer and iPad?",
  offerDescription: "Enable Google Drive sync to continue with your classes and classroom records on another device.",
  offerEnable: "Set up cross-device sync",
  offerLater: "Set up later",
  offerLaterHint: "You can open Sync settings from the page header at any time.",
  setupInProgress:
    "Another tab is enabling sync. Device data are retained. Close other Class in Order tabs, then reload this page to continue.",
  auditTitle: "Sync SQL comparison",
  auditHint:
    "Compare enabled classroom data after both devices finish syncing. Matching files still need add, edit and delete tests. These exports are plaintext; use fictional data only.",
  auditCapture: "Prepare SQL comparison file",
  auditBuild: "App build",
  auditRecords: "Classroom records",
  auditDownloadSql: "Download SQL",
  auditDownloadReport: "Download comparison report",
  auditEmpty: "No classroom records. An empty dataset cannot complete the comparison.",
  auditChanged: "Sync data changed during capture. Wait for saving and syncing to finish, then retry.",
  auditNotReady: "Connect sync and resolve pending, quarantined or conflicting operations before retrying.",
  closeAuthorizationPage: "Close authorization page",
  notEnabled: "Sync is not enabled",
  pairRequired: "Pair this device",
  automaticSetupHint:
    "Enable sync on your own device. Existing Class in Order data are retained. Sign in to the same account on another device and pair once using a QR code.",
  enableDriveSync: "Enable Google Drive sync",
  continueSetup: "Continue enabling sync",
  existingPairedRoot: "This account already has sync. Pair with another connected device.",
  checkPairDevice: "Confirm that the device shown below is yours, then select Approve pairing.",
  approvePairOnce: "Approve pairing",
  pairOptionsTitle: "Choose how this device will pair",
  pairOptionsHint:
    "Sign in to the same Class in Order account on both devices. Show the QR on one and scan it with the other.",
  pairShowHint: "Let the other device scan this code with its camera.",
  pairScanOptionHint: "Use this device’s camera to scan the other device’s pairing code.",
  pairStepsLabel: "Device pairing steps",
  pairStepScan: "Scan QR",
  pairStepApprove: "Approve on original device",
  pairStepDownload: "Download data",
  pairShowTitle: "Scan this code with the other device",
  pairWaitingTitle: "Waiting for the original device to approve",
  pairWaitingHint: "Keep this page open. The download button appears after approval.",
  pairApproveTitle: "Check the device being added",
  pairApproveHint: "Only approve the private device you are using.",
  pairApprovedTitle: "Pairing approved",
  pairApprovedHint: "Download the data on the new device next. Keep Class in Order open and online on this device.",
  pairDownloadTitle: "Download your sync data",
  pairDownloadHint: "When finished, open an existing class and check a recent record.",
  pairRefreshQr: "Generate a new QR",
  pairAnotherDevice: "Pair another device",
  pairBackToOptions: "Back to pairing options",
  pairCameraTitle: "Place the other device’s QR inside the frame",
  pairCameraHint: "The code is read automatically. You do not need to take a photo.",
  pairCameraPermission: "If the browser asks for camera access, choose Allow.",
  connectPairedDevice: "Download and connect existing sync",
  pairLocalDataRetained:
    "This device already has local data. They are retained and cloud sync has not been connected. Existing datasets are not merged automatically. Continue on the original device and contact support to arrange a transfer.",
  connectDriveNext: "This device is ready. Authorize Google Drive next.",
  driveAuthorizationComplete:
    "Google authorization is complete. Return to the original Class in Order tab, choose Check authorization again, and confirm the Drive account before connecting.",
  differentDriveRetained:
    "The selected Drive differs from the existing binding. Nothing has been switched. Authorize the original Drive again.",
  syncUsage: "Using sync",
  syncUsageSteps:
    "After first setup, authorize Google Drive. Pair other private devices once with a QR code. Sync runs automatically while Class in Order is open and online. Before switching devices, wait for Saved on this device and This device is synced, then confirm the change arrived on the other device.",
  rememberedDeviceLoss:
    "Keep at least one paired device and its website data. If website data are deleted on every paired device, Google sign-in alone cannot recover the encrypted cloud data. Do not clear website data or use private browsing.",
  setupReauthentication:
    "First setup requires a recent sign-in. Save your data, sign in to the same Class in Order account again, and continue setup. No Touch ID or passkey is required.",
  title: "Cross-device sync (development test)",
  intro: "Fictional data only. This entry uses a separate test database. Public sync is not available yet.",
  settings: "Sync settings",
  saved: "Saved on this device",
  saving: "Saving local changes",
  pending: "Waiting to sync",
  synced: "This device is synced",
  concurrentEditing: "Edit on one device at a time",
  concurrentEditingHint:
    "Overlapping changes were detected on connected devices. Stop editing on the other device. Before switching devices, wait for “This device is synced” and confirm the latest changes have arrived on the other device.",
  concurrentEditingDismiss: "Got it",
  reconnect: "Reconnect required",
  locked: "Locked",
  conflict: "Choose between saved versions",
  checking: "Checking sync",
  noBackground: "Sync may pause while the browser is closed or the device is asleep.",
  privateDevice: "Remember this private device",
  privateHint:
    "Leave this off on shared devices. Non-exportable keys are not hardware protection and do not encrypt the entire local database.",
  password: "Recovery password (at least 15 characters)",
  passwordHint:
    "Spaces and password managers are supported. Keep the file and password yourself; Class in Order cannot reset them.",
  prepare: "Create and download encrypted recovery file",
  reselect: "Select the recovery file you just downloaded",
  openPassword: "Enter recovery password",
  verifyFile: "Verify recovery file",
  fileVerified: "This recovery file unlocks the correct dataset",
  verification: "Verify an important operation",
  enroll: "Set up biometrics or PIN",
  enrolled: "Important-operation verification is set up",
  totp: "Use an authenticator code",
  enrollTotp: "Set up an authenticator instead",
  totpCode: "Six-digit authenticator code",
  confirmTotp: "Confirm authenticator",
  activate: "Enable this new sync dataset",
  verifyOperation: "Verify to approve this specific operation",
  verifyConfirm: "Start verification",
  cancel: "Cancel",
  working: "Working…",
  googleStart: "Prepare Google Drive authorization",
  googleOpen: "Open Google authorization",
  googleCheck: "Check authorization again",
  binding: "Confirm Drive binding",
  appAccount: "Class in Order account",
  driveAccount: "Drive used for sync",
  driveStorageHint:
    "Sync data is encrypted and stored in a dedicated Class in Order space in this Google account. It does not appear in the regular Drive file list, and you do not need to choose a folder.",
  bindingHint:
    "These accounts may differ. This Class in Order account will be bound to this Drive. Changing it requires a backup and an explicit migration.",
  bindingConfirm: "I confirm this Drive will store encrypted sync data",
  bind: "Confirm and connect this Drive",
  retry: "Reconnect / sync",
  oauthComplete:
    "Google authorization is complete. Return to the original Class in Order test tab to confirm the selected Drive account.",
  notConfigured: "The sync service is not available. Local data are retained. Try again later or contact support.",
  offlineOpen: "Open offline on a remembered private device",
  offlineRead:
    "Opening offline does not extend note-editing authorization. Viewing and backup remain available after expiry.",
  existingRoot:
    "This account already has sync data. Pair with an authorized device or select an encrypted recovery file.",
  pair: "Pair using a QR code",
  recover: "Use encrypted recovery file",
  chooseVersion: "Keep this version",
  conflictHint: "Both versions are retained. Choose each result; new changes will require another review.",
  changedRecord: "Record awaiting a choice {{number}}",
  pageNumber: "Page {{number}}",
  deletedVersion: "Delete this content",
  keptVersion: "Keep the content and its saved changes",
  boundDrive: "Sync Drive: {{email}}",
  deviceManagement: "Connect another device",
  connectedDevices: "Connected devices",
  connectedDevicesHint: "These devices are authorized to sync. They may be offline.",
  refreshDevices: "Refresh devices",
  currentDevice: "This device",
  deviceConnectedAt: "Connected {{date}}",
  disconnectDevice: "Disconnect",
  disconnectNamedDevice: "Disconnect {{name}} ({{id}})",
  disconnectDeviceTitle: "Disconnect {{name}} ({{id}})?",
  disconnectDeviceHint: "This device will stop syncing and keep its existing local data.",
  confirmDisconnectDevice: "Confirm disconnection",
  deviceDisconnected: "{{name}} has been disconnected.",
  disconnectRecoveryHint:
    "This sync has a recovery file. Save and verify a replacement first. The old file will expire after disconnection succeeds.",
  devicesChanged: "Devices or sync data have changed. Refresh the list and try again.",
  showPairQr: "Show pairing QR on this device",
  scanPairQr: "Scan QR from another device",
  pairScanHint:
    "On the other device, sign in to the same Class in Order account, open Sync settings and select Scan QR from another device. Do not share or save a screenshot of this code.",
  waitApproval:
    "Pairing requested. On the device already connected to sync, check the device name and select Approve pairing.",
  checkDevice: "Check the device being added, then verify this important operation.",
  pairExpiry: "This QR expires at {{time}}",
  pairExpired: "Pairing expired. Generate a new QR.",
  pastePairUrl: "Already have a pairing link?",
  pairUrl: "Short-lived pairing link",
  readPairUrl: "Confirm pairing link",
  approveDevice: "Confirm adding this device: {{name}}",
  approvePair: "Verify and approve pairing",
  pairApproved: "Pairing approved. Return to the new device and select Download and connect existing sync.",
  pairReading: "QR read. Processing pairing…",
  pairReady: "Pairing approved. Select Remember this private device, then Download and connect existing sync.",
  pairConnecting: "Pairing approved. Connecting and downloading data…",
  pairConnected: "Pairing successful. This device is connected. Open a class and check a recent record.",
  connecting: "Connecting",
  pairFinishing: "Finishing pairing. Please wait…",
  pairInterrupted:
    "Pairing is saved, but the first sync is incomplete. Select Reconnect / sync to continue. You do not need to scan the QR again.",
  pairProgressChecking: "Checking this device",
  pairProgressCheckpoint: "Verifying the sync snapshot",
  pairProgressListing: "Listing sync files",
  pairProgressDownloading: "Downloading and verifying files",
  pairProgressApplying: "Saving verified data",
  pairProgressUploading: "Sending local changes",
  pairProgressFinishing: "Finishing sync checks",
  pairProgressCount: "{{completed}} / {{total}} files",
  pairSlow: "The response is taking longer. Pairing settings are retained",
  joined: "Connected. Downloading and verifying the cloud data.",
  cameraUnavailable: "The camera is unavailable. Allow camera access or scan from the other device.",
  existingLocalBarrier:
    "This device already has data. Download and reselect an encrypted backup before choosing cloud replacement. Existing datasets are not automatically mixed. To keep local data, cancel and create a new sync generation.",
  backupPassword: "Independent backup password (at least 15 characters)",
  downloadJoinBackup: "Download independent encrypted backup before replacement",
  reselectJoinBackup: "Reselect the backup downloaded this time",
  backupVerified: "The backup covers the current local data",
  replaceFromCloud: "Confirm replacing local data with cloud data",
  joinCloud: "Download and connect existing sync",
  reenrollVerification: "Register important-operation verification for this recovered device",
  keyManagement: "Keys, recovery and sync generations",
  recreateRecovery: "Create a replacement recovery file",
  recoveryWarning:
    "This replaces recovery authorization, but an old file may still decrypt existing data. If the old file or password may have leaked, choose Rotate data key instead.",
  rotateKey: "Rotate data key",
  revokeDevice: "Revoke another device and rotate key",
  newGeneration: "Keep local data and create a new sync generation",
  deviceToRevoke: "Device to revoke",
  chooseDevice: "Choose a device",
  rotationWarning:
    "A new key and recovery file will be created. Only active devices receive future keys. Previously acquired data cannot be taken back.",
  generationWarning:
    "Create a new generation from the current local data. Old cloud ciphertext is retained and old pending operations are quarantined. Other devices must back up and explicitly join; old operations cannot replay automatically.",
  verifyAndCommit: "Verify and confirm operation",
  managementDone: "Operation complete. Keep the new verified recovery file safe.",
  legacyMigration: "Copy fictional data from the old sync prototype",
  legacyMigrationHint:
    "Only old sync test databases at this origin are read. Finish pending sync and version choices in the old version, then close its test tabs. Unknown table combinations stop the migration. The original database and cloud ciphertext are retained.",
  findLegacy: "Find old test databases",
  legacyFile: "Old test database",
  legacyNone:
    "No old sync test database was found at this origin. Export a backup from the old version when using a different origin or browser.",
  legacyPending:
    "The old version has pending operations or conflicts. Finish them there first; the original file has not been changed.",
  importLegacy: "Verify backup and copy into this empty test database",
  legacyCopied:
    "Local data copied. Create a new v2 dataset. Stop using the old version only after cloud readback and checkpoint verification succeed.",
  draftSaveRequired:
    "Finish saving notes first. If a generation change prevents saving, download a draft copy before reopening and connecting.",
  backupCurrentRequired: "This backup does not cover the current local data. Download and reselect a new backup.",
  maintenance: "Sync migration is in progress. New edits are paused and existing data are retained.",
  rebindDrive: "Back up and migrate to another Drive",
  rebindWarning:
    "Select the new Drive through Google authorization first. Confirm the account, then download and verify an independent backup and a new recovery file. Editing on this device pauses while data are encrypted, copied and read back from the new Drive. Binding changes only after success; old Drive ciphertext is retained.",
  newDriveAccount: "New sync Drive",
  selectNewDrive: "Not selected. Open Google authorization again first.",
  confirmNewDrive: "Confirm migration to the new Drive account shown above",
  resumeMigration: "Cancel this device's migration pause and recheck binding",
  resetLostVerification: "I lost the original verification methods and need to reset them",
  resetVerificationHint:
    "Reset requires a valid recovery file, password and the same Class in Order account. Original verification methods will be removed. Removing verified TOTP requires signing in again and continuing with the same file. The data key is retained.",
  verificationResetReauth:
    "Original verification methods were reset. Sign in to the same account and continue with the same recovery file, without selecting reset again.",
  reauthenticateRecovery: "Sign in again and continue recovery",
  restartWithReset: "Use recovery file to reset lost verification methods",
  draftCopyTitle: "Download an encrypted copy of this note draft",
  draftCopyHint:
    "Keep text and vector ink without replaying them into a changed sync generation. Review and add the copy later through note import.",
  draftCopyDone: "Encrypted draft downloaded. Confirm the file is saved before reopening sync.",
  close: "Close",
  initialUploadPending:
    "The first device has not finished initial sync and checkpoint verification. Keep it open and connected first.",
  keepLocalGeneration: "Keep local data and start a new sync generation",
  keepLocalNext:
    "Local content is unchanged. Open Keys, recovery and sync generations, choose a new generation, back up and verify, then approve the specific operation.",
  version: "Version {{number}}",
  errorGeneric: "The operation could not finish. Local data and saved operations are retained.",
  errorConnection: "The sync connection is temporarily unavailable. Saved operations are retained.",
  errorRate:
    "The sync service is temporarily rate-limited and will retry later. Local data and pending operations are retained.",
  errorGoogleAuth: "Authorize the originally bound Google Drive again. Local data and device unlocking are retained.",
  errorCorrupt:
    "A sync file failed verification. Local data and pending operations are retained. Make an independent backup and check the sync source.",
  errorRecovery: "The recovery file, password or dataset does not match. Check and try again.",
  errorClock: "The device clock moved backwards. Offline note authorization stopped. Correct the time and reconnect.",
  errorAccount: "Verify your Class in Order account again. Data are retained for viewing and backup.",
  errorDevice: "This device needs authorization again. Data are retained for viewing and backup.",
  errorUpdate:
    "Another device uses a newer version of Class in Order. Update this device before you sync. Data are retained for viewing and backup.",
  errorCapacity: "Sync capacity or Drive space is insufficient. New uploads stopped and data are retained.",
  errorConflict: "Choose which version to keep. New changes will be checked again.",
  errorGeneration: "The cloud sync generation changed. Back up local data before confirming the next step.",
  errorKey: "The sync key changed. Waiting to obtain the new key securely.",
  errorLegacy:
    "Finish pending operations and verify a backup in the old sync version first. Its database has not been upgraded.",
  errorPaused: "Sync paused. Return to this page to continue.",
  errorReadOnly: "Note-editing authorization expired or this device is locked. Reconnect.",
  recoveryFileName: "Class in Order sync recovery file",
  totpScan: "Scan this QR with your authenticator, then enter its code.",
  totpExisting: "Enter the code currently shown in your registered authenticator.",
  localScope: "Test database: {{device}}",
  showClassroom: "Classroom and notes",
  rootReady: "New sync created. Connect and confirm Google Drive.",
};
